export default __webpack_public_path__ + "static/media/osobni-doucovani-banner-graphics.caf353a8.png";